import { defineComponent as a, watchEffect as n, inject as r, h as s } from "vue";
import { tabsInjectionKey as i } from "./ghl-ui.es1106.js";
import { warnOnce as l, throwError as o } from "./ghl-ui.es853.js";
const b = {
  tab: [String, Number, Object, Function],
  name: {
    type: [String, Number],
    required: !0
  },
  disabled: Boolean,
  displayDirective: {
    type: String,
    default: "if"
  },
  closable: {
    type: Boolean,
    default: void 0
  },
  tabProps: Object,
  /** @deprecated */
  label: [String, Number, Object, Function]
}, f = a({
  __TAB_PANE__: !0,
  name: "TabPane",
  alias: ["TabPanel"],
  props: b,
  setup(t) {
    process.env.NODE_ENV !== "production" && n(() => {
      t.label !== void 0 && l("tab-pane", "`label` is deprecated, please use `tab` instead.");
    });
    const e = r(i, null);
    return e || o("tab-pane", "`n-tab-pane` must be placed inside `n-tabs`."), {
      style: e.paneStyleRef,
      class: e.paneClassRef,
      mergedClsPrefix: e.mergedClsPrefixRef
    };
  },
  render() {
    return s("div", {
      class: [`${this.mergedClsPrefix}-tab-pane`, this.class],
      style: this.style
    }, this.$slots);
  }
});
export {
  f as default,
  b as tabPaneProps
};
